import { Icon } from '@zenchef/ds-react'
import { token } from '@zenchef/styled-system/tokens'
import { observer } from 'mobx-react-lite'
import { Box, BoxProps } from 'rebass'
import { DefaultTheme, ThemeProps, withTheme } from 'styled-components'
import { border, BorderProps, borderRadius, BorderRadiusProps, display, height, space } from 'styled-system'

import { hoverBg, hoverBorderColor, hoverColor, transformStyles } from '@/utils/styleFns'
const getSizeAttributes = (props) => {
  switch (props.size) {
    case 'sm':
      return {
        height: props.mini ? '30px' : [2, 1]
      }
    case 'large':
      return {
        height: props.mini ? '30px' : [4, 3]
      }
    default:
      return {
        height: props.mini ? '30px' : [3, 2]
      }
  }
}

export interface SelectProps
  extends ThemeProps<DefaultTheme>,
    Omit<BoxProps, 'onChange'>,
    BorderProps,
    BorderRadiusProps {
  active?: boolean
  error?: unknown
  fontWeight?: string
  pointer?: boolean
  mini?: boolean
  hoverBg?: string
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void
}

const Select = withTheme(
  observer((props: SelectProps & { theme: DefaultTheme }) => {
    const sizeProps = getSizeAttributes(props)
    const { theme, fontWeight, active, error, pointer, value } = props
    return (
      <Box css='position: relative;'>
        <Box
          as='select'
          {...props}
          {...sizeProps}
          css={[
            `
          display: inline-flex;
          align-items: center;
          padding: 5px 10px;
          outline: none;
          appearance: none;
          transition: all .1s;
          font-family: inherit;
          border: ${
            error
              ? `${theme.borderWidths[1]} solid ${theme.colors.red.default} !important`
              : `${theme.borderWidths[1]} solid ${theme.borders.grey[2]}`
          };
                font-weight: ${fontWeight || 'normal'};
                cursor: ${pointer ? 'pointer !important' : 'default'};
                ${
                  active
                    ? `color: ${token.var('colors.background.brand.adaptive')}; border-color: ${token.var(
                        'colors.restaurant.darker'
                      )} !important;`
                    : ''
                }
                ${value === '' ? `color: ${theme.colors.grey.cool}` : ''}
          `,
            // @ts-ignore
            height,
            // @ts-ignore??
            space,
            // @ts-ignore??
            border,
            // @ts-ignore??
            display,
            // @ts-ignore??
            borderRadius,
            // @ts-ignore??
            (props) => `:hover {
              ${transformStyles(hoverBg, props)}
              ${transformStyles(hoverColor, props)}
              ${transformStyles(hoverBorderColor, props)}
            }`
          ]}
        />
        <Icon
          name='chevron-down'
          position='absolute'
          right='8px'
          top='50%'
          mt='-9px'
          fontSize='18px'
          color={active ? 'restaurant.darker' : 'charcoal.900'}
        />
      </Box>
    )
  })
)

Select.defaultProps = {
  color: 'grey.0',
  bg: 'white.default',
  border: 'grey.2',
  borderRadius: 1,
  // fontSize: ['l', 's']
  fontSize: 's'
}

export default Select
